import { useState, useEffect } from 'react';

function getWindowDimensions() {
    const width = window.innerWidth, height = window.innerHeight;
    return { width, height };
}

export default function useWindowDimensions() {
    const [windowDemensions, setWindowDemensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDemensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDemensions;
}